import * as yup from 'yup';

import { countryCodes } from 'app/constants/countries';

import { validateEmail } from 'app/utils/validations';

const myProfileFormSchema = yup.object().shape({
  firstName: yup
    .string()
    .required('First name is mandatory')
    .min(2, 'First name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "First name should only contain letters, spaces, and symbols (.-')"
    ),
  lastName: yup
    .string()
    .required('Last name is mandatory')
    .min(2, 'Last name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "Last name should only contain letters, spaces, and symbols (.-')"
    ),
  email: yup
    .string()
    .required('Email is mandatory')
    .test('Invalid email', 'Enter a valid email', (value) => validateEmail(value)),
  phoneNumber: yup.string().when('status', {
    is: (status: string) => status === 'ACTIVE',
    then: () =>
      yup
        .string()
        .required('Phone number is mandatory')
        .phone(countryCodes, 'Enter a valid phone number'),
    otherwise: () => yup.string().phone(countryCodes, 'Enter a valid phone number'),
  }),
});

export default myProfileFormSchema;
